<template>

    <Head>
        <link rel="canonical" :href="page.props.canonical" />
    </Head>

    <!-- <div class="shape-bg">
        <img class="" src="/assets/images/bg/bg-1.svg" alt="">
    </div> -->

    <svg aria-hidden="true" class="pointer-events-none fixed inset-0 z-[1000] opacity-20 mix-blend-overlay" style="position:fixed;inset:0;pointer-events:none;" xmlns="http://www.w3.org/2000/svg" version="1.1" xmlns:xlink="http://www.w3.org/1999/xlink" width="100%" height="100%" preserveAspectRatio="none">
        <defs>
            <filter id="noise-filter">
                <feTurbulence type="turbulence" baseFrequency="1" numOctaves="1" stitchTiles="stitch" result="noise"></feTurbulence>
                <feColorMatrix type="matrix" values="0 0 0 0 0
                            0 0 0 0 0
                            0 0 0 0 0
                            0 0 0 .5 0" result="coloredNoise"></feColorMatrix>
            </filter>
        </defs>
        <rect width="100%" height="100%" filter="url(#noise-filter)"></rect>
    </svg>


    <ClickSpark
        class="relative z-1"
        spark-color="#D5B3FF"
        :spark-size="12"
        :spark-radius="25"
        :spark-count="12"
        :duration="600"
        easing="ease-out"
        :extra-scale="1.2"
        >

        <div class="!bg-white">
            <Navbar />

            <main class="pt-[68px] md:pt-[76px]">
                <slot/>
            </main>

            <Footer/>
        </div>

    </ClickSpark>

    <div v-if="$page?.props?.site?.whatsapp" v-click-away="() => showWhatsapp = false">
        <Transition name="wa-backdrop">
            <div class="fixed backdrop-blur-md z-[1000] bottom-0 start-0 end-0 w-full h-screen  bg-black/50"
                v-if="showWhatsapp" @click="showWhatsapp = false"></div>
        </Transition>

        <Transition name="wa-pop">
            <div v-if="showWhatsapp"
                class="fixed z-[5000] bottom-20 start-6 md:bottom-[110px] md:start-10 bg-white shadow-xl border p-6 pt-0 px-0 rounded-xl min-w-64 max-w-72 md:max-w-96 origin-bottom">

                <div class="flex items-center justify-between mb-4 py-2 border-b shadow-md">

                    <div class="flex items-center px-4 gap-2">
                        <div
                            class="h-10 w-10 bg-brand-light p-2 flex items-center justify-center rounded-full overflow-hidden">
                            <img v-if="$page?.props?.site?.logo" :src="$page?.props?.site?.logo" alt="" loading="lazy"></img>
                        </div>
                        <div>
                            <div class="font-bold"> {{ $page?.props?.site?.name }} </div>
                            <div class="text-xs font-medium"> {{ $page?.props?.site?.email }} </div>
                        </div>
                    </div>

                    <button @click="showWhatsapp = false"
                        class="text-zinc-900 hover:text-red-500 p-3 flex items-center justify-center transition-all duration-300">
                        <PhX size="25" />
                    </button>


                </div>


                <div class="relative px-4">
                    <div id="message_1"
                        class="bg-gray-200 text-sm shadow rounded-3xl rounded-es-none ps-4 p-2 w-auto max-w-72 me-auto mb-2">
                        {{ transs.get('contact_us_message_1', locale) }}

                    </div>
                    <div id="message_2"
                        class="bg-gray-200 text-sm shadow rounded-3xl rounded-es-none ps-4 p-2 w-auto max-w-64 me-auto mb-2">
                        {{ transs.get('contact_us_message_2', locale) }}

                    </div>

                    <a id="message_3" :href="$page?.props?.site?.whatsapp" target="_blank"
                        :title="transs.get('contact_us_whatsapp', locale)"
                        :aria-label="transs.get('contact_us_whatsapp', locale)"
                        @click="trackEvent('whatsapp_click', { location: 'popup_link' })"
                        class="bg-green-100 p-2 group hover:bg-green-800 hover:text-white shadow rounded-3xl px-3 flex items-center justify-center gap-x-2 transition-all duration-300 w-max max-w-64 me-auto">
                        <PhLink size="20" weight="bold" class="" />
                        <span class=" underlinex text-green-700 group-hover:text-white">
                            {{ transs.get('contact_us_whatsapp', locale) }}
                        </span>
                    </a>

                </div>

            </div>
        </Transition>

        <button @click="toggleWhatsapp" :title="transs.get('contact_us_whatsapp', locale)"
            :aria-label="transs.get('contact_us_whatsapp', locale)" :class="pastFirstScroll
                ? 'bg-emerald-700 hover:bg-green-600 shadow-[2px_2px_0_0px_rgba(0,0,0,0.4)] hover:shadow-[0_0_0_0_rgba(0,0,0,0)]'
                : 'bg-green-600 shadow-[3px_3px_0_0px_rgba(0,0,0,1)] hover:shadow-[0_0_0_0_rgba(0,0,0,0)]'"
            class="-translate-y-1 -translate-x-1 hover:translate-y-0 hover:translate-x-0 fixed z-[9999] bottom-[calc(1.5rem+env(safe-area-inset-bottom))] start-6 md:bottom-10 md:start-10 text-white p-2 rounded-2xl transition-all duration-300">
            <PhWhatsappLogo size="35" weight="duotone" />
        </button>
    </div>
</template>

<style scoped>
.wa-backdrop-enter-active,
.wa-backdrop-leave-active {
    transition: opacity 0.3s ease;
}

.wa-backdrop-enter-from,
.wa-backdrop-leave-to {
    opacity: 0;
}

.wa-pop-enter-active {
    transition: opacity 0.3s ease, transform 0.35s cubic-bezier(0.34, 1.56, 0.64, 1);
}

.wa-pop-leave-active {
    transition: opacity 0.2s ease, transform 0.2s ease;
}

.wa-pop-enter-from,
.wa-pop-leave-to {
    opacity: 0;
    transform: translateY(16px) scale(0.85);
}

.wa-button-wrap {
    transform-origin: bottom left;
    transition: transform 0.3s ease, opacity 0.3s ease;
}

[dir="rtl"] .wa-button-wrap {
    transform-origin: bottom right;
}

.wa-button-wrap.wa-quiet {
    opacity: 0.8;
}

.wa-button-wrap:hover {
    opacity: 1;
}

@media (min-width: 768px) {
    .wa-button-wrap {
        transform: scale(0.8);
    }

    .wa-button-wrap.wa-quiet {
        transform: scale(0.65);
    }

    .wa-button-wrap:hover {
        transform: scale(0.8);
    }
}
</style>

<script setup>

    import Navbar from './Includes/Navbar.vue';
    import Footer from './Includes/Footer.vue';
    import { PhArrowArcLeft, PhArrowLeft, PhArrowRight, PhWhatsappLogo } from '@phosphor-icons/vue';
    import { onMounted, onBeforeUnmount, ref, watch, nextTick } from 'vue';
    import { transs } from '@/lib/locale'
    import { trackEvent } from '@/lib/analytics';
    import { fadeIn } from '@/lib/animations';
    import { Head, usePage, router } from '@inertiajs/vue3';
    import { computed } from 'vue';
    import { initLenis, getLenis, destroyLenis } from '@/lib/lenis';
    import { ScrollTrigger } from 'gsap/ScrollTrigger';
import ClickSpark from '@/Components/bits/animation/ClickSpark.vue';

    const page = usePage();


    const locale = computed(() => page.props.locale);

    const showWhatsapp = ref(false);
    const pastFirstScroll = ref(false);

    const toggleWhatsapp = () => {
        const opening = !showWhatsapp.value;
        showWhatsapp.value = opening;
        if (opening) trackEvent('whatsapp_click', { location: 'floating_button' });
    }

    watch(showWhatsapp, async (newVal) => {
        if (newVal) {
            document.body.style.overflow = 'hidden';

            await nextTick();

            fadeIn(document.querySelector('#message_1'), .5, .3, true)
            fadeIn(document.querySelector('#message_2'), .5, .8, true)
            fadeIn(document.querySelector('#message_3'), .5, 1.3, true)

        } else {
            document.body.style.overflow = 'auto';
        }
    })

    const handleScroll = () => {
        if (!pastFirstScroll.value && window.scrollY > 24) {
            pastFirstScroll.value = true;
        }
    };

    let stopNavigateListener = null;

    onBeforeUnmount(() => {
        window.removeEventListener('scroll', handleScroll);
        stopNavigateListener?.();
        destroyLenis();
    });

    onMounted(() => {
        window.addEventListener('scroll', handleScroll);

        initLenis();

        // Inertia swaps page content without a full reload — resync Lenis to the
        // top and re-measure ScrollTrigger positions once the new DOM is in.
        stopNavigateListener = router.on('navigate', () => {
            getLenis()?.scrollTo(0, { immediate: true });
            requestAnimationFrame(() => ScrollTrigger.refresh());
        });

        console.log(
            "%c✨ © All rights reserved by OJO. " + new Date().getFullYear(),
            "background: #725CAD; color: #fff; font-size: 14px; padding: 24px 18px; border-radius: 4px;",
        );
        console.log(
            "%c✨ Design & Development by Zain Alabdeen → https://zainalabdeen.io",
            "background: #00FFDE; color: #000; font-size: 14px; padding: 24px 18px; border-radius: 4px;",
        );

    })
</script>
